const menu = require('../../../../../components/menu/menu')

export function start(detail, htmlDt) {

      const menuElem = menuBody[detail.id]

      for (let i = 0; i < menuElem.length; i++) {
            menuElem[i].start(detail, htmlDt)
      }

      detail.html = menuElem
      detail.act = 'show'
      menu.start(detail)
}

const menuBody = {

      trMenu: [

            {
                  text: '',
                  svg: 'docs',
                  class: '',
                  dataDetail: '',

                  start: function (detail) {

                        this.text = 'PDF'
                        this.dataDetail = `data-detail='{
                              "click": [
                                    {"dest":"ripple"},
                                    {"dest":"menu", "act":"hide"},
                                    {"dest":"emailTracking", "elem":"dt", "act":"openPdf", "dbid":"${detail.dbid}"}
                              ]
                        }'`
                  }
            },
      ],
}
